import { useTranslation } from "react-i18next"
import { CABINET_HOME, CABINET_ICONS, SUMMARY_PATH, organizerHome, showAdministrator, showOrganizer, type CabinetAccess, type CabinetId, type RoleCabinetId } from "./cabinetNav"

export type CabinetEntry = { id: CabinetId | "summary"; to: string; label: string; icon: string }

/** Пункты сводки и кабинетов. Организатор встаёт перед каталогизацией, администратор — после неё. */
export const useCabinetEntries = (
  available: RoleCabinetId[],
  access: Pick<CabinetAccess, "canCreateEvents" | "canModerateEvents" | "isAdmin">,
): CabinetEntry[] => {
  const { t } = useTranslation()
  const organizer = showOrganizer(access)
  const administrator = showAdministrator(access)
  const toEntry = (id: CabinetId): CabinetEntry => ({
    id,
    to: id === "organizer" ? organizerHome(access) : CABINET_HOME[id],
    label: t(`workspaces.${id}`),
    icon: CABINET_ICONS[id],
  })
  const beforeWork = available.filter((id) => id !== "catalog")
  const work = available.filter((id) => id === "catalog")
  const entries = [
    ...beforeWork.map(toEntry),
    ...(organizer ? [toEntry("organizer")] : []),
    ...work.map(toEntry),
    ...(administrator ? [toEntry("administrator")] : []),
  ]
  if (entries.length < 2) return entries
  return [{ id: "summary", to: SUMMARY_PATH, label: t("workspaces.summary"), icon: "ri-layout-grid-line" }, ...entries]
}
